import React from "react";
import { Button } from "@mui/material";
import { CheckCircleOutline, RadioButtonUnchecked } from "@mui/icons-material";
import { Base } from ".";

interface Props {
  text: string;
  onClick?: (e?: any) => void;
  disabled?: boolean;
  type?: "primary" | "secondary" | "delete" | "active" | "inactive";
  fullWidth?: boolean;
  height?: {
    xs?: string | number;
    sm?: string | number;
    md?: string | number;
    lg?: string | number;
    xl?: string | number;
  };
  selection?: boolean;
}

const ActionButton: React.FC<Props> = (props) => {
  const { text, onClick, disabled, type, fullWidth, selection } = props;
  return (
    <Button
      sx={{
        width: fullWidth ? "100%" : "auto",
        height: props.height ?? "auto",
      }}
      startIcon={
        !!selection ? (
          type === "active" ? (
            <CheckCircleOutline />
          ) : (
            <RadioButtonUnchecked />
          )
        ) : undefined
      }
      onClick={onClick}
      variant="contained"
      disabled={disabled}
      color={
        type === "active"
          ? "success"
          : type === "inactive"
          ? "info"
          : type === "secondary"
          ? "secondary"
          : type === "delete"
          ? "error"
          : "primary"
      }
    >
      <Base.Text text={text} variant="body2" center />
    </Button>
  );
};

export default ActionButton;
